module.exports = __webpack_public_path__ + "static/media/rouge.1b852d2e.jpg";